module.exports = __webpack_public_path__ + "img/up_from.80425cec.svg";